import styled from 'styled-components';
import { Box } from '../../components';

const Container = styled(Box)``;

Container.defaultProps = {
  mx: 'auto',
  px: 4,
  maxWidth: 'lg'
};

export default Container;
